import { FeedbackIssueBadge } from '@/components/feedbacks/feedback-issue-badge.js';
import { SessionFeedbackIssue } from '@airreading/common/data';

export const ReadonlyIssuesList = ({ issues, testId }: { issues: SessionFeedbackIssue[]; testId?: string }) => {
  if (issues.length === 0) {
    return testId ? <span data-testid={testId}>-</span> : null;
  }

  return (
    <div className="flex flex-wrap items-start gap-1">
      {issues.map((item, index) => (
        <FeedbackIssueBadge
          feedbackIssue={item}
          key={item}
          testId={testId && (issues.length === 1 ? testId : `${testId}-${index + 1}`)}
        />
      ))}
    </div>
  );
};
